import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { DxChartComponent } from "devextreme-angular";
import { NewNicaFormComponent } from "../../nica-form/new-nica-form.component";
import { Apiservice } from "../../../services/api.service";
import { alert } from "devextreme/ui/dialog";
import jsPDF from "jspdf";
import { NgxSpinnerService } from "ngx-spinner";


@Component({
	selector: "app-crm-stat-procedure",
	templateUrl: "./crm_stat_procedure.component.html",
	styleUrls: ["./crm_stat_procedure.component.css"],
})

export class CrmStatProcedureComponent implements OnInit {
	@ViewChild("statisticheProcedure", { static: false }) newNicaForm: NewNicaFormComponent;
	@ViewChild('chartMain', { static: false }) chartMain: DxChartComponent;
	@ViewChild('chartTrend', { static: false }) chartTrend: DxChartComponent;
	api: string = "statisticaprocedure";
	filterEditor: string = "";
	queryString: string = "";
	dataSource: { [key: string]: any }[] = [];
	trendSource: { [key: string]: any }[] = []
	annoCorrente = new Date().getFullYear().toString();
	proceduraSelected: string | null = null
	moduloSelected: string | null = null
	anniSelected: number | null = 0
	CAGR: { [key: string]: any } | undefined
	totDitot: number = 0
	selectedDate: string[] = [];
	type = 'bar'
	esportSetting = [
		{ value: "SVG", name: "SVG", icon: "globe" },
		{ value: "JPEG", name: "JPEG", icon: "image" },
		{ value: "PDF", name: "PDF", icon: "pdffile" },
	];
	selectType = [
		{ value: "bar", name: "Barre" },
		{ value: "spline", name: "Linee" },
	]
	mesi = [
		{ id: 1, nome: "Gennaio" },
		{ id: 2, nome: "Febbraio" },
		{ id: 3, nome: "Marzo" },
		{ id: 4, nome: "Aprile" },
		{ id: 5, nome: "Maggio" },
		{ id: 6, nome: "Giugno" },
		{ id: 7, nome: "Luglio" },
		{ id: 8, nome: "Agosto" },
		{ id: 9, nome: "Settembre" },
		{ id: 10, nome: "Ottobre" },
		{ id: 11, nome: "Novembre" },
		{ id: 12, nome: "Dicembre" },
	];
	campi = [
		{ value: new Date().getFullYear().toString(), argument: "desMese" },
	];
	CustomButtonSetForm = [
		// {
		// 	widget: 'dxButton',
		// 	stylingMode: 'contain',
		// 	text: 'Applica',
		// 	icon: 'dx-icon-unpin',
		// 	hint: 'Applica Filtri',
		// 	visible: true,
		// 	disabled: false,
		// 	id: 1
		// },
		// {
		// 	widget: 'dxButton',
		// 	stylingMode: 'contain',
		// 	text: 'Cancella',
		// 	icon: 'dx-icon-clearformat',
		// 	hint: 'Cancella Filtri',
		// 	visible: true,
		// 	disabled: false,
		// 	id: 2
		// }
	]
	filtriAnno = false;

	constructor(private cdr: ChangeDetectorRef,
		private apiservice: Apiservice, private spinner: NgxSpinnerService
	) { }

	ngOnInit(): void {
		//this.applicaFiltri()

	}

	customizeToolTipTrend(event) {
		const data = event.point.data
		////console.log(data)
		return data
	}
	customizeToolTipMain(event) {
		//console.log(event)
		const data = event.point.data;
		const datiAssociati = data.datiAssociati || {};
		const anni = !isNaN(parseInt(event.seriesName)) ? [event.seriesName] : Object.keys(datiAssociati || this.selectedDate);
		const result = anni.map(anno => {
			const totale = !isNaN(parseInt(event.seriesName)) ? data[event.seriesName] : (event.originalValue || 0);
			const rawDati = datiAssociati[anno] || [];
			const grouped = new Map();
			rawDati.forEach(item => {
				const sigla = item.m_isModulo === null ? item.Sigla : item.m_Sigla;
				const nome = item.m_isModulo === null ? item.Des : item.m_Des;
				const isModulo = item.m_isModulo === null ? item.isModulo : item.m_isModulo;
				if (!grouped.has(sigla)) {
					grouped.set(sigla, {
						anno: anno,
						nome: nome,
						sigla: sigla,
						isModulo: isModulo,
						count: 1,
					});
				} else {
					const entry = grouped.get(sigla);
					entry.count += 1;
				}
			});

			const dettagli = Array.from(grouped.values()).map(entry => ({
				anno: entry.anno,
				nome: entry.nome,
				sigla: entry.sigla,
				isModulo: entry.isModulo,
				count: entry.count,
			}));

			return { anno, dettagli, totale };
		});

		return result;
	}


	creaTitoloStampa() {
		let titolo = 'Statistiche Procedure'
		let anno = `Anno: ${new Date().getFullYear().toString()}`
		if (this.newNicaForm.dataSet['anniConfronto'] && this.newNicaForm.dataSet['anniConfronto'] !== null) {
			anno = `Dal ${new Date().getFullYear()} al ${new Date().getFullYear() - this.newNicaForm.dataSet['anniConfronto']}`
		}
		return `${titolo} - ${anno}`
	}
	creaDettagliScarica() {

		let campiDaAggregare = this.campi.map(x => x.value);
		if (campiDaAggregare.length === 0) {
			return [];
		}
		let risultatiMensili: { [key: string]: any } = {};
		this.dataSource.forEach(dato => {
			let mese = dato.desMese;

			if (!risultatiMensili[mese]) {
				risultatiMensili[mese] = { mese: mese, value: 0 };
			}

			campiDaAggregare.forEach(campo => {
				risultatiMensili[mese].value += dato[campo] || 0;
			});
		});

		let filtro = Object.values(risultatiMensili).map(dato => `${dato.mese} = ${dato.value}`);

		return filtro.length > 0 ? filtro : [];
	}
	creaDettagliFiltro() {
		let filtro = []
		if (this.newNicaForm.dataSet["Des_CodModulo"] !== null || this.newNicaForm.dataSet["Des_CodProcedura"] !== null) {
			filtro.push(``)
			if (this.newNicaForm.dataSet["Des_CodModulo"] === null) {
				filtro.push(`Principale: ${this.newNicaForm.dataSet["Des_CodProcedura"]}`)
			} else if (this.newNicaForm.dataSet["Des_CodProcedura"] === null) {
				filtro.push(`Opzionale: ${this.newNicaForm.dataSet["Des_CodModulo"]}`)
			} else {
				filtro.push(`Principale: ${this.newNicaForm.dataSet["Des_CodProcedura"]}`)
				filtro.push(`Opzionale: ${this.newNicaForm.dataSet["Des_CodModulo"]}`)
			}
			filtro.push(``)
		}

		if (filtro.length > 0) {
			return filtro
		} else {
			return []
		}
	}
	creaDettagliStampa() {
		let filtro = ''
		if (this.newNicaForm.dataSet["CodModulo"] !== null || this.newNicaForm.dataSet["CodProcedura"] !== null) {
			filtro += '<h3>Dettagli Filtri</h3>'
			filtro += '<ul>'
			if (this.newNicaForm.dataSet["CodModulo"] === null) {
				filtro += `<li><strong>Principale:</strong> ${this.newNicaForm.dataSet["Des_CodProcedura"]}</li>`;
			} else if (this.newNicaForm.dataSet["CodProcedura"] === null) {
				filtro += `<li><strong>Opzionale:</strong> ${this.newNicaForm.dataSet["Des_CodModulo"]}</li>`;
			} else {
				filtro += `
				<li><strong>Principale:</strong> ${this.newNicaForm.dataSet["Des_CodProcedura"]}</li>
				<li><strong>Opzionale:</strong> ${this.newNicaForm.dataSet["Des_CodModulo"]}</li>
				`;
			}
			filtro += '</ul>'
		}
		const x = this.creaDettagliScarica()
		if (x.length > 0) {
			filtro += '<h3>Dettagli Leggenda</h3>'
			filtro += '<ul>'
			x.forEach((y) => {
				filtro += `<li>${y}</li>`
			})
			filtro += '</ul>'
		}
		if (filtro !== '') {
			return filtro
		} else {
			return ''
		}
	}

	customizeTextLegend(event) {
		return !isNaN(parseInt(event.seriesName)) ? `Anno ${event.seriesName}` : event.seriesName
	}
	customizeTextValue(event) {
		return `${event.valueText}%`
	}
	onItemClick(event) {
		////console.log(event);
		const arrayClass: string[] = Object.values(event.element.classList)
		if (arrayClass.includes('printBtn')) {
			this.stampaCustom({ chartMain: this.chartMain ? this.chartMain.instance.svg() : undefined, chartTrend: this.chartTrend ? this.chartTrend.instance.svg() : undefined }, this.creaDettagliStampa(), this.creaTitoloStampa())
			//this.chartMain.instance.print();
		}
		if (arrayClass.includes('esportBtn')) {
			if (event.itemData) {
				// if (event.itemData.value === 'PDF') {
				// 	return this.scaricaPdf(this.chartMain.instance.svg(), this.creaTitoloStampa(), this.creaDettagliFiltro(), this.creaDettagliScarica())
				// } else {
				if (this.chartTrend) {
					/* this.scaricaCustom({ chartMain: this.chartMain.instance.svg(), chartTrend: this.chartTrend.instance.svg() }, event.itemData.value) */
					this.chartMain.instance.exportTo(`statistiche_procedure_mensile_${new Date().toLocaleString("it-IT", {
						day: "2-digit",
						month: "numeric",
						year: "numeric",
					})}`, event.itemData.value);
					this.chartTrend.instance.exportTo(`statistiche_procedure_mensile_${new Date().toLocaleString("it-IT", {
						day: "2-digit",
						month: "numeric",
						year: "numeric",
					})}`, event.itemData.value);
				} else {
					this.chartMain.instance.exportTo(`statistiche_procedure_mensile_${new Date().toLocaleString("it-IT", {
						day: "2-digit",
						month: "numeric",
						year: "numeric",
					})}`, event.itemData.value);
				}
				// }
			}
		}
		if (arrayClass.includes('resetBtn')) {
			this.reset()
		}
		if (arrayClass.includes('selectType')) {
			if (event.itemData) {
				this.type = event.itemData.value
				this.cdr.detectChanges();
				this.chartMain.instance.refresh()
			}
		}
		return;
	}
	legendClick({ target: series }): void {
		const item = series
		if (item.isVisible()) {
			return item.hide();
		} else {
			return item.show();
		}
	}
	emittedInitForm(event) {

	}
	emittendButtonPushForm(event) {
		// if (event === 1) {
		// 	this.applicaFiltri();
		// 	this.proceduraSelected = this.newNicaForm.dataSet['Des_CodProcedura']
		// 	this.moduloSelected = this.newNicaForm.dataSet['Des_CodModulo']
		// 	this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
		// 	// this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
		// 	// this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
		// 	this.cdr.detectChanges();
		// } else {
		// 	this.reset()
		// 	this.cdr.detectChanges();
		// }
	}
	emittedItemsEvetForm(event) {
		////console.log(event);
		if (event.name === "onValueChanged") {
			this.applicaFiltri();
			this.proceduraSelected = this.newNicaForm.dataSet['Des_CodProcedura']
			this.moduloSelected = this.newNicaForm.dataSet['Des_CodModulo']
			this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
			this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
			this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
			this.cdr.detectChanges();
		}
	}
	//!------------------------------------------------------------------ PRIVATE --------------------------------------------------------
	private async getApi() {
		this.spinner.show()
		const url = this.api + this.queryString;
		await this.apiservice
			.GetApiRest(url)
			.then((response: any) => {
				this.spinner.hide()
				return this.processResponseForChart(response);
			})
			.catch((error) => {
				this.spinner.hide()
				//console.error(error);
				return alert("Errore nella generazione dei dati", "Errore");
			});
	}

	private processResponseForChart(response: any): void | Promise<void> {
		this.totDitot = 0
		if (response && response.items) {
			const dati = response.items;
			let objMain = {};
			let objTrend = {}
			this.mesi.forEach((element) => {
				objMain[element.id] = {
					desMese: element.nome,
					Mese: element.id,
				};
				this.campi.forEach((x) => {
					objMain[element.id][x.value] = 0;
				});
			});
			dati.forEach((item: any) => {
				const key = item.Mese;
				item.desMese = this.mesi[key - 1].nome;
				if (!objMain[key]) {
					objMain[key] = {};
				}
				Object.assign(objMain[key], item);
			});
			dati.forEach((dato) => {
				Object.keys(dato).forEach((key) => {
					if (!isNaN(parseInt(key))) {
						this.totDitot += dato[key]
						if (!objTrend[key]) {
							objTrend[key] = {
								anno: key,
								value: 0
							}
						}
						this.campi.forEach((x) => {
							if (!objTrend[x.value]) {
								objTrend[x.value] = {
									anno: x.value.toString(),
									value: 0
								}
							}
						})
						objTrend[key].value += dato[key]
					}
				})
			})
			if (this.filtriAnno) {
				this.trendSource = this.calcoliTrend(Object.values(objTrend));
			}
			this.dataSource = this.calcoliMain(Object.values(objMain));

			////console.log(objMain);
			////console.log(this.trendSource);
			return;
		} else {
			return alert("Errore nella generazione dei dati, ti preghiamo riprovare", "Errore");
		}
	}
	private calcolaTassoCrescita(dati) {
		let risultati = [];
		if (dati.length <= 1) {
			dati.forEach(dato => {
				dato.variazione = 0,
					dato.tassoCrescita = 0,
					dato.andamento = 'Stabile'
			});
			return dati
		}
		for (let i = 0; i < dati.length; i++) {
			const annoPrecedente = dati[i - 1];
			if (!annoPrecedente) {
				risultati.push({
					anno: dati[i].anno,
					value: dati[i].value,
					variazione: 0,
					tassoCrescita: 0,
					andamento: 'Nominale',
					percentuale: dati[i].percentuale
				});
				continue
			}
			const annoCorrente = dati[i];

			let variazione = annoCorrente.value - annoPrecedente.value;
			let tassoCrescita: string | number = 0;
			let andamento = "Nominale";

			if (annoPrecedente.value === 0) {
				tassoCrescita = annoCorrente.value > 0 ? annoCorrente.value * 100 : 0; // Evitiamo divisione per zero
				andamento = annoCorrente.value > 0 ? "Crescita" : "Stabile";
			} else {
				tassoCrescita = ((variazione / annoPrecedente.value) * 100).toFixed(2);
				andamento = variazione > 0 ? "Crescita" : variazione < 0 ? "Diminuzione" : "Stabile";
			}

			risultati.push({
				anno: annoCorrente.anno,
				value: annoCorrente.value,
				variazione: variazione,
				tassoCrescita: tassoCrescita,
				andamento: andamento,
				percentuale: annoCorrente.percentuale
			});
		}

		return risultati;
	}

	private calcolaCAGR(dati) {
		// Trova il primo anno con valore positivo
		const primoAnnoValido = dati.find(d => d.value > 0);
		const ultimoAnno = dati[dati.length - 1];


		if (!primoAnnoValido) return undefined; // Nessun valore positivo disponibile

		const valoreIniziale = primoAnnoValido.value;
		const valoreFinale = ultimoAnno.value;
		const anni = dati.length;


		const cagr = anni !== 0 ? (Math.pow((valoreFinale / valoreIniziale), (1 / anni)) - 1) * 100 : ultimoAnno.value * 100;


		return { value: `${cagr.toFixed(1)}%`, andamento: cagr.toFixed(1).toString().includes('-') };
	}

	private calcoliTrend(dati: { [key: string]: any }[]) {
		// 1. Calcola la somma totale dei valori
		const totale = dati.reduce((acc, item) => acc + item.value, 0);

		// 2. Calcola la percentuale per ogni elemento e aggiorna l'array
		dati.forEach(item => {
			item.percentuale = (item.value / totale) * 100;
		});
		const finalDati = this.calcolaTassoCrescita(dati);
		this.CAGR = this.calcolaCAGR(dati)
		return finalDati
	}
	private calcoliMain(obj: { [key: string]: any }[]) {
		const dati = obj;
		// 1) Calcola la somma e la media per ogni singolo mese
		const datiConSommaEMedia = dati.map((item) => {
			// Filtra solo le chiavi "numeriche" con valore non null
			const anniValidi = Object.keys(item).filter(
				(k) => !isNaN(parseInt(k)) && item[k] !== null && item[k] !== 0
			);
			// Somma dei valori non null
			const sommaMese = anniValidi.reduce(
				(acc, anno) => acc + item[anno],
				0
			);
			// Conteggio dei valori non null
			const count = anniValidi.length;
			// Media = somma / quanti anni validi
			const mediaMese = count > 0 ? sommaMese / count : 0;
			// Restituisce l’oggetto con chiavi aggiuntive
			return {
				...item,
				sommaMese,
				mediaMese  // <--- questa è la media specifica di questo mese
			};
		});
		// 2) Calcola il totale complessivo di tutte le sommeMese
		const totaleComplessivo = datiConSommaEMedia.reduce(
			(acc, curr) => acc + curr.sommaMese,
			0
		);
		// 3) Calcola la percentuale di ciascun mese sul totale
		const datiFinali = datiConSommaEMedia.map((item) => {
			// Calcola la percentuale di questo mese sul totale
			const percentualeMese = totaleComplessivo
				? (item.sommaMese / totaleComplessivo) * 100
				: 0;

			return {
				...item,
				percentualeMese: parseFloat(percentualeMese.toFixed(2)), // Es: 12.5
			};
		});
		return datiFinali;
	}

	private processFiltro(query, data) {
		return query.replace(/\[([^\]]+)\]/g, (match, variable) => {
			return data.hasOwnProperty(variable) ? data[variable] : match;
		});
	}

	private applicaFiltri(): void {
		//console.log(this.newNicaForm);
		const newNicaForm = this.newNicaForm || undefined;
		if (newNicaForm) {
			const dataSet = newNicaForm.dataSet || undefined;
			const elementRef = newNicaForm.elementRef || undefined;
			const escludiModuli = dataSet['escludiModuli'] ? dataSet['escludiModuli'] === true : false;
			const codModulo = dataSet['CodModulo'] || undefined;
			const CodAgente = dataSet['CodAgente'] || undefined;
			const RagSoc1_CodAgente = dataSet['RagSoc1_CodAgente'] || undefined;
			const codProcedura = dataSet['CodProcedura'] || undefined;
			const anniConfronto = (dataSet['anniConfronto'] !== null && dataSet['anniConfronto'] !== undefined) ? dataSet['anniConfronto'] : 0;
			// 1. Gestione disabilitazione modulo
			const moduloEditor = elementRef['Des_CodModulo'] || undefined;
			if (moduloEditor) {
				moduloEditor.editorComponent.isDisabled = escludiModuli;
				moduloEditor.htmlElement.disabled = escludiModuli;
			}
			// 2. Costruzione filtro
			if (!codModulo && !codProcedura && !CodAgente) {
				this.filterEditor = escludiModuli ? `?anni=[anniConfronto]&$EscludiModuli` : `?anni=[anniConfronto]`;
			} else if (!codModulo && codProcedura && !CodAgente) {
				this.filterEditor = `?CodProcedura=[CodProcedura]&anni=[anniConfronto]`;
			} else if (codModulo && !codProcedura && !CodAgente) {
				this.filterEditor = escludiModuli
					? `?anni=[anniConfronto]&$EscludiModuli`
					: `?CodModulo=[CodModulo]&anni=[anniConfronto]`;
			} else if (!codModulo && !codProcedura && CodAgente) {
				this.filterEditor = escludiModuli
					? `?CodAgente=[CodAgente]&anni=[anniConfronto]&$EscludiModuli`
					: `?CodAgente=[CodAgente]&anni=[anniConfronto]`;
			} else if (codModulo && !codProcedura && CodAgente) {
				this.filterEditor = escludiModuli
					? `?CodAgente=[CodAgente]&anni=[anniConfronto]&$EscludiModuli`
					: `?CodAgente=[CodAgente]&CodModulo=[CodModulo]&anni=[anniConfronto]`;
			} else if (!codModulo && codProcedura && CodAgente) {
				this.filterEditor = `?CodAgente=[CodAgente]&CodProcedura=[CodProcedura]&anni=[anniConfronto]`;
			} else {
				this.filterEditor = escludiModuli
					? `?CodAgente=[CodAgente]&CodProcedura=[CodProcedura]&anni=[anniConfronto]&$EscludiModuli`
					: `?CodAgente=[CodAgente]&CodProcedura=[CodProcedura]&CodModulo=[CodModulo]&anni=[anniConfronto]`;
			}
			this.queryString = this.processFiltro(this.filterEditor, dataSet);
			// 3. Gestione filtri anni e CAGR
			this.filtriAnno = anniConfronto > 0;
			if (!this.filtriAnno) {
				this.CAGR = undefined;
			}
			// 4. Altri metodi e aggiornamenti
			this.aggiungiCampi(anniConfronto);
			// 5. Selezione finale
			this.proceduraSelected = dataSet['Des_CodProcedura'];
			this.moduloSelected = dataSet['Des_CodModulo'];
			this.anniSelected = anniConfronto;
			this.getApi();
			this.cdr.detectChanges();
			return
		}
		this.queryString = '?anni=0&$EscludiModuli';
		this.proceduraSelected = null;
		this.moduloSelected = null;
		this.anniSelected = 0;
		this.aggiungiCampi(0);
		this.getApi();
		this.cdr.detectChanges();
		return
	}


	private reset() {
		Object.keys(this.newNicaForm.dataSet).forEach((x) => {
			if (x === 'Des_CodProcedura' || x === 'Des_CodModulo' || x === 'RagSoc1_CodAgente') {
				this.newNicaForm.elementRef[x].component.showClearButton = false
			}
			if (x === 'anniConfronto') {
				return this.newNicaForm.dataSet[x] = 0
			}
			if (x === 'escludiModuli') {
				return this.newNicaForm.dataSet[x] = false
			}
			return this.newNicaForm.dataSet[x] = null
		});
		this.filtriAnno = false;
		this.queryString = "";
		this.filterEditor = "";
		this.type = 'bar'
		this.applicaFiltri()
		this.proceduraSelected = this.newNicaForm.dataSet['Des_CodProcedura']
		this.moduloSelected = this.newNicaForm.dataSet['Des_CodModulo']
		this.anniSelected = this.newNicaForm.dataSet['anniConfronto']
		this.cdr.detectChanges();
	}

	private aggiungiCampi(anni: number) {
		let newCampiObj: { [key: number]: { value: string; argument: string } } = {};
		this.selectedDate = []
		for (let x = 0; x <= anni; x++) {
			if (anni > 0) {
				newCampiObj[x] = {
					value: (new Date().getFullYear() - x).toString(),
					argument: "desMese",
				};
			} else {
				newCampiObj[0] = {
					value: (new Date().getFullYear()).toString(),
					argument: "desMese",
				};
			}

			this.selectedDate.push((new Date().getFullYear() - x).toString())
		}
		this.campi = Object.values(newCampiObj)/* .sort((a, b) => parseInt(a.value) - parseInt(b.value)) as { value: string; argument: string }[] */;
		return;
	}

	private stampaCustom(svgElement: { chartMain: string, chartTrend: string }, innerHtml = '', titolo = 'Titolo Della Stampa') {
		let blobMain = undefined
		let urlMain = undefined
		if (svgElement.chartMain) {
			blobMain = new Blob([svgElement.chartMain], { type: "image/svg+xml" });
			urlMain = URL.createObjectURL(blobMain);
		}
		let blobTrend = undefined
		let urlTrend = undefined
		if (svgElement.chartTrend) {
			blobTrend = new Blob([svgElement.chartTrend], { type: "image/svg+xml" });
			urlTrend = URL.createObjectURL(blobTrend);
		}
		const iframe = document.createElement("iframe");
		iframe.style.position = "absolute";
		iframe.style.width = "0px";
		iframe.style.height = "0px";
		iframe.style.border = "none";
		document.body.appendChild(iframe);
		const doc = iframe.contentWindow.document;
		doc.open();
		doc.write(`
			<html>
					<head>
							<title></title>
							<style>
                    @page {
                        size: landscape; /* portrait o landscape */
                        margin: 3mm; 
                    }

										.chartContent{
											display: flex;
											flex-direction: row;
											align-items: center;
											justify-content: center;
											gap: 12px;
										}
                </style>
					</head>
					<body>
							<div class="container">
								<h1 class="titolo">${titolo}</h1>
								<div ${urlTrend ? 'class="chartContent"' : ''} > ${urlMain ? `<img class="img" ${urlTrend ? 'width="800" height="300"' : ''} src="${urlMain}" />` : ''} ${urlTrend ? `<img class="img" height="300" width="200" src="${urlTrend}" />` : ''}</div>
								<div class="content">${innerHtml}</div>
							</div>
							<script>
									window.onload = function() {
											window.print();
											setTimeout(() => {
													window.parent.document.body.removeChild(window.frameElement);
											}, 1000);
									};
							</script>
					</body>
			</html>
	`);
		doc.close();
	}
	// scaricaPdf(svgString, titolo, des = [], info = []) {
	// 	/* 		// Clonare l'SVG per modificarlo senza alterare l'originale
	// 			const svgClone = svgElement.cloneNode(true);
	// 			// Convertire l'SVG in stringa
	// 			const svgString = new XMLSerializer().serializeToString(svgClone); */

	// 	// Creare un oggetto immagine dal blob SVG
	// 	const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
	// 	const url = URL.createObjectURL(svgBlob);
	// 	const img = new Image();

	// 	// Creare un contenitore HTML per la struttura del PDF
	// 	const container = document.createElement('div');
	// 	container.style.width = '3000px';
	// 	container.style.height = '2000px';
	// 	container.style.display = 'flex'
	// 	container.style.flexDirection = 'column'
	// 	container.style.justifyItems = 'center'
	// 	container.style.justifyContent = 'top'
	// 	container.style.fontFamily = "Arial, sans-serif";
	// 	container.innerHTML += `
	// 	<h1 style="text-align:center; font-size:110px">${titolo}</h1>
	// 	`;
	// 	container.innerHTML += '<div id="chartCont" style="margin-right:auto;margin-left:auto;margin-bottom:30px;"></div>'
	// 	if (des.length > 0) {
	// 		container.innerHTML += '<div id="desTxt"></div>'
	// 		let desTxt = container.querySelector('#desTxt')
	// 		/* 			desTxt.innerHTML += '<h3 style="text-align:center; font-size:70px">Dettagli Filtri</h3>' */
	// 		des.forEach((x) => {
	// 			desTxt.innerHTML += `
	// 			<p style="text-align:center; font-size:60px">${x}</p>
	// 			`
	// 		})
	// 	}
	// 	if (info.length > 0) {
	// 		container.innerHTML += '<h3 style="text-align:center; font-size:70px;">Dettagli dati</h3>'
	// 		container.innerHTML += `<div id="txtCont" style="width: 1360px;margin-left: auto;margin-right: auto;justify-content: center;justify-items: start;align-content: center;grid-auto-columns: max-content;display: grid;grid-template-columns: auto auto auto auto;grid-gap: 6px 30px;">`
	// 		let txtCont = container.querySelector('#txtCont') as HTMLDivElement
	// 		txtCont.style.border = '1px solid'
	// 		txtCont.style.padding = '9px'
	// 		info.forEach((x) => {
	// 			txtCont.innerHTML += `<span style="font-size:50px;">${x}</span>`
	// 		})
	// 		container.innerHTML += `</div>`
	// 	}
	// 	//console.log(container)
	// 	img.onload = function () {
	// 		// Creare un canvas con queste dimensioni
	// 		const canvas = document.createElement("canvas");
	// 		canvas.width = 3000;
	// 		canvas.height = 900;
	// 		const ctx = canvas.getContext("2d");

	// 		ctx.fillStyle = "white";
	// 		ctx.fillRect(0, 0, canvas.width, canvas.height);

	// 		// Mantieni le proporzioni ridimensionando l'immagine
	// 		ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
	// 		const tmp = container.querySelector('#chartCont').appendChild(canvas)
	// 		/* 			tmp.style.height = '1600px';
	// 					tmp.style.width = '1600px'; */
	// 		tmp.style.marginLeft = 'auto'
	// 		tmp.style.marginRight = 'auto'
	// 		// Usa il metodo html() per convertire il contenitore in PDF
	// 		new jsPDF({
	// 			orientation: 'landscape',
	// 			unit: 'px',
	// 			format: 'a4'
	// 		}).html(container, {
	// 			callback: function (pdf) {
	// 				// Salva il PDF una volta completata la conversione
	// 				pdf.save(`stat_procedure_pie_${new Date().toLocaleString("it-IT", {
	// 					day: "2-digit",
	// 					month: "numeric",
	// 					year: "numeric"
	// 				})}.pdf`);
	// 			},
	// 			x: 0,    // coordinata x di partenza
	// 			y: 0,    // coordinata y di partenza
	// 			margin: [20, 20, 9, 20],
	// 			html2canvas: {
	// 				scale: 0.2
	// 			}
	// 		});

	// 		// Liberare la memoria dell'URL creato per il blob SVG
	// 		URL.revokeObjectURL(url);
	// 	};

	// 	// Iniziare il caricamento dell'immagine
	// 	img.src = url;
	// 	return
	// }
}

//TODO ----------------------------------------------------------------------------------------------------------------------------------------------
/* 
! Ritorno dal server
+ se filtro per un modulo o per una procedura posso filtrare per anno max 5 ricevo questo 
	{
		mese: idDelMese,
		totPercentuale:100, //? questo lo aggiungo io
		mediaPercent:50,  //? questo lo aggiungo io
		annoCorrente: 72.5, //# sempre aggiunto 
		annoCorrente -1: 223.6, //* se selezionato lo vedo altrimenti no  =somma delle vendite totali per l'anno in quel mese
		annoCorrente -2: 36, //* se selezionato lo vedo altrimenti no =somma delle vendite totali per l'anno in quel mese
		annoCorrente -3: 21, //* se selezionato lo vedo altrimenti no =somma delle vendite totali per l'anno in quel mese
		annoCorrente -4: 33, //* se selezionato lo vedo altrimenti no =somma delle vendite totali per l'anno in quel mese
		annoCorrente -5: 65, //* se selezionato lo vedo altrimenti no =somma delle vendite totali per l'anno in quel mese
	}, 

+ se cerco all'inizio senza nessun filtro
	{
		mese: idDelMese,
		annoCorrente: 72.5, //=somma delle vendite totali per l'anno corrente in quel mese
	},
	altri record dei mesi....

	//----------------------------------------------------------------------------------------------------
		campi = [
		{ value: 2025, argument: 'mese' },//? sempre visibile con l'anno corrente
		{ value: 2024, argument: 'mese' },//? se imposto anno
		{ value: 2023, argument: 'mese' },//? se imposto anno
		{ value: 2022, argument: 'mese' },//? se imposto anno
		{ value: 2021, argument: 'mese' },//? se imposto anno
		 = max 5 anni indietro
	];
*/
